<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin-bottom: 3px"
  >
    <path
      d="M19 10.4976H18C18 14.9158 14.4183 18.4976 10 18.4976V19.4976V20.4976C15.5228 20.4976 20 16.0204 20 10.4976H19ZM10 19.4976V18.4976C5.58172 18.4976 2 14.9158 2 10.4976H1H0C0 16.0204 4.47715 20.4976 10 20.4976V19.4976ZM1 10.4976H2C2 6.07928 5.58172 2.49756 10 2.49756V1.49756V0.497559C4.47715 0.497559 0 4.97471 0 10.4976H1ZM10 1.49756V2.49756C14.4183 2.49756 18 6.07928 18 10.4976H19H20C20 4.97471 15.5228 0.497559 10 0.497559V1.49756ZM14 10.4976H13C13 12.1544 11.6569 13.4976 10 13.4976V14.4976V15.4976C12.7614 15.4976 15 13.259 15 10.4976H14ZM10 14.4976V13.4976C8.34315 13.4976 7 12.1544 7 10.4976H6H5C5 13.259 7.23858 15.4976 10 15.4976V14.4976ZM6 10.4976H7C7 8.8407 8.34315 7.49756 10 7.49756V6.49756V5.49756C7.23858 5.49756 5 7.73613 5 10.4976H6ZM10 6.49756V7.49756C11.6569 7.49756 13 8.8407 13 10.4976H14H15C15 7.73613 12.7614 5.49756 10 5.49756V6.49756ZM16.364 4.1336L15.6569 3.42649L12.1213 6.96203L12.8284 7.66913L13.5355 8.37624L17.0711 4.8407L16.364 4.1336ZM12.8284 13.326L12.1213 14.0331L15.6569 17.5686L16.364 16.8615L17.0711 16.1544L13.5355 12.6189L12.8284 13.326ZM7.17157 7.66913L7.87868 6.96202L4.34315 3.42649L3.63604 4.1336L2.92893 4.8407L6.46447 8.37624L7.17157 7.66913ZM7.17157 13.326L6.46447 12.6189L2.92893 16.1544L3.63604 16.8615L4.34315 17.5686L7.87868 14.0331L7.17157 13.326Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  width: {
    type: [String, Number],
    default: "20",
  },
  height: {
    type: [String, Number],
    default: "21",
  },
  color: {
    type: String,
    default: "white",
  },
});
</script>
